module.exports = __webpack_public_path__ + "static/infusion-71c36799779b5345ba17a9e7f8571d97.jpg";